import { getPackageHref, getSiPackageHref } from "app/common/hrefs";
import { swSettings } from "app/common/services/swSettings";
import { isSI } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import { setUrlQueryParam } from "./setUrlQueryParam";

export interface IGoToPackagesPageParams {
    presetId?: string;
    packageId?: string;
    currency?: string;
    promo?: string;
    withUpgradeToAnnual?: boolean;
    withUpgradeToSeo?: boolean;
    discountBanner?: boolean;
    hook?: string;
}

const returnUrlParam = "returnUrl";
const presetIdParam = "presetId";

export const getPackagesPageHref = (params: IGoToPackagesPageParams = {}): string => {
    const isSalesApp = isSI(swSettings);
    const { presetId, packageId, currency, promo, withUpgradeToAnnual, withUpgradeToSeo, discountBanner, hook } =
        params;
    const url = new URL(isSalesApp ? getSiPackageHref() : getPackageHref());

    url.searchParams.set(returnUrlParam, location.href);
    setUrlQueryParam(url, presetIdParam, presetId);
    setUrlQueryParam(url, "packageId", packageId);
    setUrlQueryParam(url, "Currency", currency);
    setUrlQueryParam(url, "promo", promo);
    setUrlQueryParam(url, "withUpgradeToAnnual", withUpgradeToAnnual);
    setUrlQueryParam(url, "withUpgradeToSeo", withUpgradeToSeo);
    setUrlQueryParam(url, "discountBanner", discountBanner);
    setUrlQueryParam(url, "hook", hook);

    return url.toString();
};

export function goToPackagesPage(params: IGoToPackagesPageParams = {}): void {
    window.open(getPackagesPageHref(params));
}
